import React from 'react';

const FixedSideButtons = () => {
  // Seitliche Buttons entfernt auf Benutzerwunsch
  return null;
};

export default FixedSideButtons;